import CancelableRegulation, {
  CancelableRegulationInit,
} from './CancelableRegulation';
import ChangeableRegulation, {
  ChangeableRegulationInit,
} from './ChangeableRegulation';
import ReservableRegulation, {
  ReservableRegulationInit,
} from './ReservableRegulation';

export interface RegulationInit {
  reservableFrom?: ReservableRegulationInit;
  reservableUntil?: ReservableRegulationInit;
  cancelable: CancelableRegulationInit;
  changeable?: ChangeableRegulationInit;
}

export default class Regulation {
  public readonly reservableFrom?: ReservableRegulation;
  public readonly reservableUntil?: ReservableRegulation;
  public readonly cancelable: CancelableRegulation;
  public readonly changeable?: ChangeableRegulation;

  constructor(init: RegulationInit) {
    this.reservableFrom = init.reservableFrom
      ? new ReservableRegulation(init.reservableFrom)
      : undefined;
    this.reservableUntil = init.reservableUntil
      ? new ReservableRegulation(init.reservableUntil)
      : undefined;
    this.cancelable = new CancelableRegulation(init.cancelable);
    this.changeable = init.changeable
      ? new ChangeableRegulation(init.changeable)
      : undefined;
  }
}
